import type { PropsWithChildren } from 'react';
import { BreadcrumbSeparator } from './BreadcrumbSeparator';

type BreadcrumbListProps = PropsWithChildren;

export const BreadcrumbList = ( { children }: BreadcrumbListProps ) => {

  return (
    <ol className={ 'flex flex-row gap-1 items-center' }>
      <BreadcrumbSeparator className={ 'md:hidden rotate-180' } />
      { children }
    </ol>
  )
}
BreadcrumbList.displayName = 'BreadcrumbList';
